var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getDataValue, removeDataValue } from '@juvare/json-data-util';
import React from 'react';
import { QuickFilterSelect } from '../components';
import { getItems } from './getItems';
import { getSafeValueProvider } from './getSafeValueProvider';
export function quickFilterSelect(params) {
    const safeValueProvider = getSafeValueProvider(params.valueProvider);
    return {
        quickFilter: {
            render: (props) => (React.createElement(QuickFilterSelect, Object.assign({}, props, { dataPath: params.dataPath, label: params.label, values: params.values, valueProviderType: params.valueProviderType, valueProvider: safeValueProvider, sx: params.sx, "data-test": params.dataTest }))),
            dataPath: params.dataPath,
        },
        widgetConfig: params.widget === 'form.radio'
            ? {
                type: 'form.radio',
                key: params.dataPath,
                label: params.label,
                values: params.values
                    ? params.emptyRadioItemLabel
                        ? [{ value: undefined, label: params.emptyRadioItemLabel }, ...params.values]
                        : params.values
                    : undefined,
                valueProvider: (safeValueProvider === null || safeValueProvider === void 0 ? void 0 : safeValueProvider.type) || params.valueProviderType
                    ? {
                        type: (safeValueProvider === null || safeValueProvider === void 0 ? void 0 : safeValueProvider.type) || params.valueProviderType,
                        params: safeValueProvider === null || safeValueProvider === void 0 ? void 0 : safeValueProvider.params,
                        paramsFromFormData: safeValueProvider === null || safeValueProvider === void 0 ? void 0 : safeValueProvider.paramsFromFormData,
                    }
                    : undefined,
            }
            : {
                type: 'form.select',
                key: params.dataPath,
                label: params.label,
                values: params.values,
                valueProvider: (safeValueProvider === null || safeValueProvider === void 0 ? void 0 : safeValueProvider.type) || params.valueProviderType
                    ? {
                        type: (safeValueProvider === null || safeValueProvider === void 0 ? void 0 : safeValueProvider.type) || params.valueProviderType,
                        params: safeValueProvider === null || safeValueProvider === void 0 ? void 0 : safeValueProvider.params,
                        paramsFromFormData: safeValueProvider === null || safeValueProvider === void 0 ? void 0 : safeValueProvider.paramsFromFormData,
                    }
                    : undefined,
            },
        getFilterChips: (filterData, filterDependencyMap) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const value = getDataValue(filterData, params.dataPath);
            if (value != null) {
                const items = yield getItems({
                    values: params.values,
                    valueProviderType: params.valueProviderType,
                    valueProvider: safeValueProvider,
                    valueProvidersFromProps: params.valueProviders,
                    filterData,
                    formConfigContext: params.formConfigContext,
                });
                const label = (_b = (_a = items.find((item) => item.value === value)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : value;
                return [
                    {
                        label,
                        onRemoveChip: (chipFilterData) => handleRemoveChip(chipFilterData, params.dataPath, filterDependencyMap),
                        groupId: params.dataPath,
                    },
                ];
            }
            else {
                return [];
            }
        }),
    };
}
function handleRemoveChip(filterData, dataPath, dependencyMap) {
    const newFilterData = JSON.parse(JSON.stringify(filterData));
    removeDataValue(newFilterData, dataPath);
    const dependantFilterArray = dependencyMap[dataPath];
    if (dependantFilterArray && dependantFilterArray.length > 0) {
        dependantFilterArray.forEach((dependantFilterKey) => {
            removeDataValue(newFilterData, dependantFilterKey);
        });
    }
    return newFilterData;
}
